module.exports = __webpack_public_path__ + "images/icons/icon-minus-d2eb0198.svg";